export enum RetailOrderProgressStep {
	Info,
	Template,
	Measure,
	Confirm,
	Schedule,
	Install,
	DeliveredToStore,
	POReceived,
	QualityCheck,
	UploadFiles
}